import { DSLogoStar, DSLogoStarProps } from './DSLogoStar';

export type DSProgressIndicatorProps = Pick<DSLogoStarProps, 'dataTestId' | 'progress' | 'width'>;

export function DSProgressIndicator({ dataTestId, progress, width }: DSProgressIndicatorProps) {
  return <DSLogoStar progress={progress} dataTestId={dataTestId} width={width} />;
}
